var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRefugeesAndEquality = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Refugee-Immigration-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Refugee Immigration 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.28 18.09a3.12 3.12 0 0 1 -1.14 0.83l-1.8 0.75 1.9 3A1.66 1.66 0 1 0 16.08 21Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16 6.48a3 3 0 1 0 -2.64 -3.32 3 3 0 0 0 2.64 3.32Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.57 17.53a1.67 1.67 0 0 0 1 -2 17.88 17.88 0 0 0 -4 -6.67 2 2 0 0 0 -1.42 -0.66 1.76 1.76 0 0 0 -1.54 0.8l-1.1 1.38 -2.27 -1.65a1.67 1.67 0 0 0 -2.35 0.2 1.66 1.66 0 0 0 0.2 2.34l2.76 2.15a2.76 2.76 0 0 0 1.69 0.8 1.57 1.57 0 0 0 0.81 -0.22l1.81 -1.33 1.62 2.41 -3 1.26a1.67 1.67 0 0 0 -1 1.81l0.57 3.42A1.69 1.69 0 0 0 7.79 23H8a1.24 1.24 0 0 0 0.27 0 1.66 1.66 0 0 0 1.35 -2l-0.35 -2.11Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34 9.72c-0.5 -1.82 -3.34 -3.64 -4.63 -4.38L20 2.63a0.76 0.76 0 0 0 -0.36 -1 0.74 0.74 0 0 0 -1 0.36l-0.85 1.8 -2.06 -1.7a0.75 0.75 0 1 0 -1 1.15l1.6 1.33L11 5.71a0.75 0.75 0 0 0 0.16 1.48h0.16l6.22 -1.33c-0.76 1.4 -2.07 4.17 -1.6 5.9 0.65 2.38 2.47 2.54 4.51 2S24 12.1 23.34 9.72Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRefugeesAndEquality);
export default ForwardRef;